import { EventPublicStatus } from '../models/event';

const getToastColor = (status: EventPublicStatus) => {
  if (status === EventPublicStatus.Ready) {
    return 'bg-success-100 text-success-800';
  }
  if (status === EventPublicStatus.PendingApproval) {
    return 'bg-warning-100 text-warning-800';
  }
  if (status === EventPublicStatus.NoTicketsAvailable) {
    return 'bg-error-100 text-error-800';
  }
  if (status === EventPublicStatus.Expired) {
    return 'bg-error-300 text-error-800';
  }
  if (status === EventPublicStatus.Inactive) {
    return 'bg-error-100 text-error-800';
  }
  return '';
};

export default getToastColor;
